const normalizeDescriptionPart = (value) => {
  if (value === null || value === undefined) return "";
  const text = String(value).trim();
  if (!text) return "";
  return text;
};

export const extractLineItemDescriptionText = (value) => {
  if (value === null || value === undefined) return "";
  const rawText = typeof value === "string"
    ? value
    : (value.description ?? value.label ?? value.name ?? value.value ?? "");
  return normalizeDescriptionPart(rawText);
};

export const buildJurisLineItemDescription = (supplierName, sourceValue) => {
  const normalizedSupplierName = normalizeDescriptionPart(supplierName);
  const descriptionText = extractLineItemDescriptionText(sourceValue);
  return [normalizedSupplierName, descriptionText].filter((part) => part).join(' - ');
};

export const extractExistingJurisDescriptionBody = (description) => {
  const text = normalizeDescriptionPart(description);
  if (!text) return "";
  const separatorIndex = text.indexOf(" - ");
  if (separatorIndex === -1) return text;
  return normalizeDescriptionPart(text.slice(separatorIndex + 3));
};

export const withJurisLineItemDescription = ({
  isJurisFormat,
  supplierName,
  item,
  fieldName,
  fieldValue,
  descriptionSource,
}) => {
  const normalizedFieldValue = fieldValue ?? "";
  const updatedItem = {
    ...item,
    [fieldName]: normalizedFieldValue,
  };

  if (!isJurisFormat) {
    return updatedItem;
  }

  return {
    ...updatedItem,
    Description: buildJurisLineItemDescription(supplierName, descriptionSource ?? normalizedFieldValue),
  };
};
